import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@mui/material';

const MasterAccount: React.FC = () => {
  const [formData, setFormData] = useState({
    clinicName: '',
    contactPerson: '',
    address: '',
    email: '',
    phone: '',
    website: '',
    loginId: '',
    password: '',
  });

  const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log('Clinic Name:', formData.clinicName);
    console.log('Contact Person:', formData.contactPerson);
    console.log('Address:', formData.address);
    console.log('Email:', formData.email);
    console.log('Phone:', formData.phone);
    console.log('Website:', formData.website);
    console.log('Login ID:', formData.loginId);
    console.log('Password:', formData.password);
    // 実際の送信処理はここで行う
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" component="h1" gutterBottom>
        Clinic Registration
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <TextField label="Clinic Name" required fullWidth margin="normal" onChange={handleChange('clinicName')} value={formData.clinicName} />
        <TextField label="Contact Person" fullWidth margin="normal" onChange={handleChange('contactPerson')} value={formData.contactPerson} />
        <TextField label="Address" required fullWidth margin="normal" onChange={handleChange('address')} value={formData.address} />
        <TextField label="Email" fullWidth margin="normal" onChange={handleChange('email')} value={formData.email} />
        <TextField label="Phone" required fullWidth margin="normal" onChange={handleChange('phone')} value={formData.phone} />
        <TextField label="Website" fullWidth margin="normal" onChange={handleChange('website')} value={formData.website} />
        <TextField label="Login ID" required fullWidth margin="normal" onChange={handleChange('loginId')} value={formData.loginId} />
        <TextField label="Password" required type="password" fullWidth margin="normal" onChange={handleChange('password')} value={formData.password} />
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Register
        </Button>
      </Box>
    </Container>
  );
};

export default MasterAccount;
